import React, { FC, ReactNode } from 'react'
import { StyledButton } from './styled'

export interface ButtonCircleProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fill?: 'filled' | 'outlined' | 'empty'
  size?: 'large' | 'medium' | 'small'
  icon?: ReactNode
  color?: 'onPrimary' | 'onWhite' | 'monochrome' | 'primary'
  disabled?: boolean
  className?: string
}

const BtnCircleV2: FC<ButtonCircleProps> = ({
  fill = 'filled',
  size = 'large',
  color = 'onPrimary',
  disabled = false,
  icon,
  className,
  ...props
}) => {
  return (
    <StyledButton {...props} fill={fill} size={size} color={color} disabled={disabled} className={className}>
      {icon}
    </StyledButton>
  )
}

export default BtnCircleV2
